/* CNC MARKET GUARD — send a buyer to their own storefront, not just the first time.
   ================================================================================

   WHAT TRACY HIT, 2026-09-30, on her own phone: "I literally went straight to caffeine
   and curses, and I was on the .com. But I shouldn't be on that. I should be on the
   .com.au... That should have auto-directed me to .com.au. That's the whole point of it."
   Her cart showed $36.98 USD while Shop Pay then quoted her AUD.

   WHY SHOPIFY'S OWN REDIRECT DID NOT SAVE HER. It fires ONCE per browser and then stops.
   Measured on live from an Australian connection, five sequential visits in one session:

     1. asked /                            -> 302 to caffeineandcurses.com.au   AUD
     2. asked /products/velaris-hoodie     -> stayed on caffeineandcurses.com   USD
     3. asked /collections/fourth-wing…    -> stayed on caffeineandcurses.com   USD
     4. asked /products/the-suriel-shirt   -> stayed on caffeineandcurses.com   USD
     5. asked /  (the SAME url as step 1)  -> stayed on caffeineandcurses.com   USD

   The first redirect writes a `localization` cookie and Shopify then treats every later
   arrival on .com as the buyer's own choice. Most links pointing at this shop are .com —
   Google results, email, the Instagram bio, anything shared — so a returning Australian
   lands on the US storefront and shops in USD.

   Shopify still knows where they are. /browsing_context_suggestions.json answers, from the
   same .com page that is serving USD:

     {"detected_values":{"country_name":"Australia","country":{"handle":"AU",…}},"suggestions":[]}

   `suggestions` is empty precisely because the cookie has settled it — but detected_values
   is still the truth, and that is what this reads.

   TWO RULES THIS MAY NEVER BREAK.

   1. NEVER MOVE A BUYER WHO IS CARRYING SOMETHING. A cart is a per-domain cookie and cannot
      cross from .com to .com.au — measured: two items and 108.36 USD on .com, 0 items on
      .com.au in the same session, with the .com cart still intact afterwards. Redirecting
      mid-journey would empty their bag in front of them. So this only ever acts on an empty
      cart, which is the arrival case and the one that matters.

   2. NEVER OVERRIDE A DELIBERATE CHOICE. If they used the country selector, that is their
      decision and it stands for the rest of the session.

   The destination is NOT hardcoded. It submits Shopify's own localization form with the
   detected country, exactly as the footer selector does, and lets Shopify resolve where that
   market lives — so this keeps working if a market moves between a domain and a subfolder,
   and when the Australian catalogue splits out onto .com.au properly.
   ================================================================================ */
(function () {
  'use strict';

  var ONCE = 'cncMarketGuard';       /* acted (or decided not to) this session */
  var CHOSE = 'cncMarketChosen';     /* the buyer used the country selector themselves */

  /* A buyer's own choice outranks anything here, for the rest of the session. */
  document.addEventListener('submit', function (e) {
    try {
      if (e.target && e.target.querySelector && e.target.querySelector('[name="country_code"]')) {
        sessionStorage.setItem(CHOSE, '1');
      }
    } catch (err) {}
  }, true);

  function url(path) {
    return (typeof window.cncUrl === 'function')
      ? window.cncUrl(path)
      : ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/')
        .replace(/\/?$/, '/') + String(path).replace(/^\/+/, '');
  }

  function go(countryCode) {
    var f = document.createElement('form');
    f.method = 'post';
    f.action = url('localization');
    f.style.display = 'none';
    [['form_type', 'localization'], ['utf8', '✓'], ['_method', 'put'],
     ['country_code', countryCode], ['return_to', location.pathname + location.search]]
      .forEach(function (pair) {
        var i = document.createElement('input');
        i.type = 'hidden'; i.name = pair[0]; i.value = pair[1];
        f.appendChild(i);
      });
    document.body.appendChild(f);
    f.submit();
  }

  function run(servedCountry) {
    try {
      if (window.Shopify && window.Shopify.designMode) return;   /* never in the editor */
      /* NEVER IN A THEME PREVIEW. The preview cookie is per-domain, so moving a previewer
         from .com to .com.au drops them onto the LIVE theme and the preview silently ends —
         it happened while timing this very change, and it would have happened to Tracy the
         moment she opened a ?preview_theme_id= link from Australia. Shopify exposes the
         running theme's role, which is "main" only on the published one. */
      if (window.Shopify && window.Shopify.theme && window.Shopify.theme.role !== 'main') return;
      if (sessionStorage.getItem(ONCE)) return;
      if (sessionStorage.getItem(CHOSE)) return;
      if (!servedCountry) return;
    } catch (err) { return; }

    Promise.all([
      fetch(url('browsing_context_suggestions.json')).then(function (r) { return r.json(); }),
      fetch(url('cart.js')).then(function (r) { return r.json(); })
    ]).then(function (out) {
      var detected = (((out[0] || {}).detected_values || {}).country || {}).handle;
      var items = (out[1] || {}).item_count;

      /* Mark BEFORE acting: a redirect that somehow lands back here must not loop. */
      try { sessionStorage.setItem(ONCE, '1'); } catch (err) {}

      if (!detected) return;
      if (detected.toUpperCase() === String(servedCountry).toUpperCase()) return;
      if (items > 0) return;          /* rule 1 — never empty someone's bag */

      go(detected);
    }).catch(function () { /* a guess is worse than leaving them where they are */ });
  }

  window.cncMarketGuard = run;
})();
